import { getAuthMeInfo } from '@bariendo/lib/profile';
import { getReferenceString, MedplumClient } from '@medplum/core';

export async function fetchBot<T>(medplum: MedplumClient, botName: string, input: object): Promise<T> {
  if (import.meta.env.DEV) {
    const currentUser = (await getAuthMeInfo(medplum)).profile;

    const response = await fetch(`${import.meta.env.VITE_LOCAL_SERVER}/${botName}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Current-User': getReferenceString(currentUser) ?? '',
      },
      body: JSON.stringify({ ...input }),
    });

    if (!response.ok) {
      let errorMessage = `Couldn't execute bot (${response.status})`;
      try {
        const errorBody = await response.text();
        if (errorBody) {
          // Try to parse as JSON first (in case it's a structured error)
          try {
            const errorJson = JSON.parse(errorBody);
            errorMessage = errorJson.message || errorJson.error || errorJson.errorMessage || errorMessage; // Skip to avoid displaying json error
          } catch {
            // eslint-disable-next-line no-console
            console.error('Error parsing bot response', errorBody);
          }
        }
      } catch {
        // If we can't read the response body, use the default message
      }
      throw new Error(errorMessage);
    }
    return (await response.json()) as T;
  }

  try {
    const botResponse = await medplum.executeBot(
      {
        system: 'http://bariendo.com/bots',
        value: botName,
      },
      { ...input }
    );

    return botResponse as T;
  } catch (error: unknown) {
    let errorMessage = "Couldn't execute bot";

    if (error instanceof Error) {
      try {
        const json = JSON.parse(error.message);
        errorMessage = json.errorMessage || json.message || json.error || errorMessage;
      } catch {
        errorMessage = error.message;
      }
    } else if (typeof error === 'string') {
      errorMessage = error;
    }

    throw new Error(errorMessage);
  }
}
